const mixin = {
	methods: {
		onContentModalEmit(obj){
			console.log(obj)
			this.modalComponent = 'ModalContent'
			this.modalComponentProps = { ...obj }
			this.$refs.fullscreenModal.show()
		},
		onSaveDraftModalEmit(obj){
			console.log(obj)
			this.modalComponent = 'SaveDraftContent'
			this.modalComponentProps = { ...obj }
			this.$refs.fullscreenModal.show()
		}
	}
}

export default mixin 